import { render, staticRenderFns } from "./Addasset.vue?vue&type=template&id=78474026&scoped=true&"
import script from "./Addasset.vue?vue&type=script&lang=js&"
export * from "./Addasset.vue?vue&type=script&lang=js&"
import style0 from "./Addasset.vue?vue&type=style&index=0&id=78474026&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78474026",
  null
  
)

export default component.exports